import { connect } from "react-redux";
import loginActions from "ducks/loginRegister";
import appPath from "utils/appPath";
import { browserHistory } from "react-router";
import { SCREENS, FLOWS } from "common/constants/Constants";
import userActions from "ducks/user";
import { setThinking, doneThinking } from "ducks/thinking";
import Message from "utils/Message";

export function createMapStateToProps() {
    return (state) => {
        const {
            config: { bloombergSiteUrl },
            loginRegister = {},
            thinking
        } = state;

        return {
            thinking,
            bloombergSiteUrl,
            industry: loginRegister.industry || "",
            jobTitle: loginRegister.jobTitle || "",
            seniority: loginRegister.seniority || ""
        };
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        checkProfession() {
            return dispatch(userActions.startFetchingUser())
                .then(({ industry, jobTitle, seniority }) => {
                    if (!industry || !jobTitle || !seniority) {
                        return;
                    }

                    return dispatch(routeAfterProfession());
                })
                .catch((error) => {
                    if (error.status === 401) {
                        browserHistory.push(appPath.withIframePrefix(SCREENS.REGISTER));
                    }
                });
        },

        onIndustryChange(newIndustry) {
            return dispatch(loginActions.setIndustry(newIndustry));
        },

        onJobTitleChange(newJobTitle) {
            return dispatch(loginActions.setJobTitle(newJobTitle));
        },

        onSeniorityChange(newSeniority) {
            return dispatch(loginActions.setSeniority(newSeniority));
        },

        updateProfession(professionInfo) {
            dispatch(setThinking());

            return dispatch(loginActions.startUpdateProfession(professionInfo))
                .then(() => dispatch(routeAfterProfession()))
                .then(() => dispatch(doneThinking()))
                .catch(() => dispatch(doneThinking()));
        },

        skipIndustryScreen() {
            return dispatch(routeAfterProfession());
        }
    };
}

function routeAfterProfession() {
    return (_, getState) => {
        const {
            loginRegister: { flow }
        } = getState();

        if (appPath.isIframePath()) {
            Message.closeWindow();

            return;
        }

        const nextScreen = flow === FLOWS.REGISTER
            ? SCREENS.SIGNUP_NEWSLETTERS
            : SCREENS.ACCOUNT;

        browserHistory.push(appPath(nextScreen));
    };
}

function createProfessionContainer(component) {
    return connect(
        createMapStateToProps(),
        mapDispatchToProps
    )(component);
}

export default createProfessionContainer;
